module.exports = __webpack_public_path__ + "static/media/b2b.0e2d4d67.png";